import React, { useState } from 'react';
import '../styles/selection.css';
import Text from 'ui/Text';
import successIcon from 'images/success_icon_revert.svg';
import dropdownModal from 'features/SpilKlub/HOCs/dropdownModal';

const DeadlineSelectionPopup = ({
    onClose = () => {},
    options,
    onChange = () => {},
    value,
}) => {
    const [activeSelection, setActiveSelection] = useState(value || '');

    return (
        <>
            <div className={'sk-selection-description'}>
                <Text
                    size={'x1'}
                    color={'#333'}
                    margin={'0 0 0 8px'}
                    padding={'2px 0'}
                    lh={'20'}
                >
                    Vælg, hvornår det senest skal være muligt at købe andele til
                    din kupon.
                </Text>
            </div>
            {options.length && (
                <div className={'sk-selection-options'}>
                    {options.map((item, key) => {
                        return (
                            <div key={key} className={'flex'}>
                                <Text
                                    size={'x15'}
                                    color={'#333'}
                                    onClick={() => {
                                        setActiveSelection(item[1]);
                                        onChange(item[0]);
                                        onClose();
                                    }}
                                >
                                    {item[1]}
                                </Text>
                                {value === item[0] && (
                                    <img src={successIcon} alt="checked" />
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </>
    );
};
export default dropdownModal(DeadlineSelectionPopup);
